import moment from "moment";
import EditorTipTap from "../../../components/EditorTipTap/EditorTipTap";
import { useState } from "react";

export default function Termino({ data }) {
    const [texto, setTexto] = useState("");

    // último termino firmado por el usuario 
    if (data.terminoUsuario.valorEsperado.idTermino > 0)
    {
        return (
            <>
                <div>
                    Especificaciones de términos y condiciones vigente <strong>aceptados el día { moment(data.terminoUsuario.valorEsperado.fecha).format("DD/MM/yyyy HH:mm:ss") }</strong>.
                </div>                
                <br />
                {data && 
                <EditorTipTap
                    value={data?.terminoUsuario?.valorEsperado?.texto || ""}
                    editable={false}
                    onChange={(html) => setTexto(html)}
                />
                }
            </>
        );
    }
    else
    {
        return (
            <h2>
                Aún no ha firmado el acuerdo vigente.
            </h2>
        );
    }
};